export default __webpack_public_path__ + "62de3ec300229bec1f7c1d3809272187.svg";